// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#bscbing1{position:relative;width:33%;height:100%;background-color:rgba(6,30,93,.5);box-sizing:border-box;margin-right:10px}#bscbing1 .box{height:100%;width:100%}", ""]);
// Exports
module.exports = exports;
